export default __webpack_public_path__ + "static/media/Public.933f0d14.png";